//SPECIAL_OCCASION list
export const SPECIAL_OCCASIONS_LIST_REQUEST = 'SPECIAL_OCCASIONS_LIST_REQUEST';
export const SPECIAL_OCCASIONS_LIST_SUCCESS = 'SPECIAL_OCCASIONS_LIST_SUCCESS';
export const SPECIAL_OCCASIONS_LIST_FAIL = 'SPECIAL_OCCASIONS_LIST_FAIL';
export const SET_NAVIGATION_MENU_VISIBLE = 'SET_NAVIGATION_MENU_VISIBLE';
